import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function FoundersDetails({data}) {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    gsap.fromTo(
      section,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  return (
    <div
      ref={sectionRef}
      className="lg:h-screen max-w-[1400px] mr-auto 2xl:ml-auto flex justify-center items-center py-10 px-5 lg:py-0 lg:px-0 font-mono"
    >
      <div className="flex justify-between xl:gap-28 gap-10 flex-col lg:flex-row">
        <img src={data.image} alt="Founder" className="lg:h-[500px]" />
        <div className="founder-info text-left space-y-4">
          <h1 className="text-6xl font-medium">{data.title}</h1>
          <h3 className="text-4xl font-poppins">{data.subTitle}</h3>
          <p className="text-xl pt-6 pb-6 font-poppins">{data.description}</p>

          <div className="md:text-left text-right">
            <b className="text-xl">{data.name}</b>
            <p className="text-xl">{data.position}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoundersDetails;
